<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  methods: {
    setRem() {
      const baseSize = 16; // 设计稿宽度的1/100

      const baseWidth = 1920; // 设计稿的宽度，例如1920px

      const clientWidth =
        document.documentElement.clientWidth || window.innerWidth;

      const rem = (clientWidth / baseWidth) * baseSize;

      document.documentElement.style.fontSize = `${rem}px`;
    },
  },
  mounted() {
    this.setRem();

    window.addEventListener("resize", this.setRem);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setRem);
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue